import React, {FC} from 'react';

import {RadioButton} from '@zoefin/design-system';

import {useTimeoutAction} from '@/hooks/useTimeoutAction';

import {AUTO_ADVANCE_MS} from '../../constants';
import {useFhs, useFhsActor} from '../../store/FhsContext/hooks';
import type {FhsField} from '../../types';

import styles from './styles.module.scss';

interface QuestionRadioProps {
  field: FhsField;
  options: {label: string; value: string}[];
}

const QuestionRadio: FC<QuestionRadioProps> = ({field, options}) => {
  const actor = useFhsActor();
  const {formData, errors, touched} = useFhs();
  const schedule = useTimeoutAction();

  const current = formData[field];
  const error = touched[field] ? errors[field] : undefined;

  const handleSelect = (val: string) => {
    actor.send({type: 'UPDATE_FIELD', field, value: val});
    schedule(() => actor.send({type: 'NEXT'}), AUTO_ADVANCE_MS);
  };

  return (
    <div className={styles.questionRadio}>
      <div className={styles.questionRadio__grid}>
        {options.map((opt) => (
          <RadioButton
            key={opt.value}
            id={`fhs-${String(field)}-${opt.value}`}
            name={String(field)}
            value={opt.value}
            label={opt.label}
            checked={current === opt.value}
            className={styles.questionRadio__card}
            checkHandler={(val) => handleSelect(val)}
            onClick={() => {
              if (current === opt.value) handleSelect(opt.value);
            }}
          />
        ))}
      </div>
      <div className={styles.questionRadio__errorSlot}>
        {error && <p className={styles.questionRadio__error}>{error}</p>}
      </div>
    </div>
  );
};

export default QuestionRadio;
